import { useDispatch } from 'react-redux';

import {
	TransactionTypeAliasAuthenticationTypeOperationInputDto,
	AliasAuthenticationTypeOperationOutputDto,
	Bank,
	TransactionType,
	TransactionsLabel,
} from '@api/ecommerce-xp';
import { useAutoFetch } from '@hooks';
import { saveSuccessServiceResponse, useUserInput } from '@store';

export const useFetchAuthenticatorType = () => {
	const dispatch = useDispatch();
	const { selectedAccount } = useUserInput();
	const transactionType: TransactionType = TransactionType.ECommerceSubscription;
	const transactionLabels: TransactionsLabel[] | null = null;
	return useAutoFetch<
		TransactionTypeAliasAuthenticationTypeOperationInputDto,
		AliasAuthenticationTypeOperationOutputDto
	>({
		data: {
			accountId: selectedAccount?.account.id,
			bank: Bank.MillenniumBcp,
			language: 'PT',
			transaction: transactionType,
			transactionAmount: 0,
			transactionCurrency: 'EUR',
			transactionLabels: transactionLabels,
		},
		cache: {
			key: 'aliasAuthenticationType',
			time: 0,
		},
		withLoading: false,
		operationKey: 'aliasAuthenticationType',
		onSuccess: (res) => {
			if (res.data) {
				dispatch(saveSuccessServiceResponse({ aliasAuthenticationType: res.data }));
			}
		},
	});
};
